import { useCurrency } from 'hooks/Tokens'
import { useTradeExactIn } from 'hooks/Trades'
import { tryParseAmount } from 'state/swap/hooks'
import tokens from 'constants/tokens'


const useGetMJTUsdtLpPrice = () => {
  const mjtAddress = tokens.mjt.address[process.env.REACT_APP_CHAIN_ID as string]
  const usdtAddress = tokens.usdt.address[process.env.REACT_APP_CHAIN_ID as string]
  const inputCurrency = useCurrency(mjtAddress)
  const outputCurrency = useCurrency(usdtAddress)
  const parsedAmount = tryParseAmount('1', inputCurrency ?? undefined)
  const bestTradeExactIn = useTradeExactIn(parsedAmount, outputCurrency ?? undefined)
  // console.log('bestTradeExactIn', bestTradeExactIn)
  const price = bestTradeExactIn?.executionPrice.toSignificant(6)
  return price ? parseFloat(price) : 0
}

export const useTokenUsdtPrice = (tokenAddress) => {

  // const [price, setPrice] = React.useState<number>(0)

  const usdtAddress = tokens.usdt.address[process.env.REACT_APP_CHAIN_ID as string]
  const inputCurrency = useCurrency(tokenAddress)
  const outputCurrency = useCurrency(usdtAddress)
  const parsedAmount = tryParseAmount('1', inputCurrency ?? undefined)
  const bestTradeExactIn = useTradeExactIn(parsedAmount, outputCurrency ?? undefined)
  const p = bestTradeExactIn?.executionPrice.toSignificant(6)
  return parseFloat(p) ?? 0

  // React.useEffect(() => {
  //   async function getPrice() {
  //     const block = await getLatestBlock()
  //     const p = await getTokenPrice(tokenAddress.toLowerCase(), block)
  //     setPrice(() => p)
  //   }
  //   // mainnet use graph price
  //   if (Number(process.env.REACT_APP_CHAIN_ID) === ChainId.MAINNET) {
  //     getPrice()
  //   } else {
  //     const p = bestTradeExactIn?.executionPrice.toSignificant(6)
  //     setPrice(() => {
  //       return parseFloat(p) ?? 0
  //     })
  //   }
  // }, [tokenAddress, bestTradeExactIn])

  // return price

}

export default useGetMJTUsdtLpPrice
